import React from 'react'
import 'bootstrap/dist/css/bootstrap.css';

import { convertirAMiles } from './utilerias/funciones'
//
const Card = ({ title, number, logo, url=null }) => {
  return (
    <a target="_blank" href={url ? url : "#"} style={{ textDecoration:"none", lineHight: "1.5" }}>
      <div className="card">
        <div className="card-body ecosur-numeralia-elemento">
          <div className="col-12 text-center">
            <i className={logo} style={{ fontSize: "50px" }}></i>
          </div>
          <div className="row ">
            <div className="col-12 text-center element-econum">
              <h4 className="num-eco-num">{convertirAMiles(number)}</h4>
            </div>
            <div className="col-12 text-center element-econum">
              <p className="ecosur-text-mini" style={{lineHeight: "1"}}>{title}</p>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
}

export default Card